<template>
    <div id="tool-bar">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "ToolBar"
    }
</script>

<style scoped>
    #tool-bar{
        background-color: rgb(241, 241, 241);
        border: 1px solid rgb(204, 204, 204);
        display: flex;
        padding: 0 5px;
        margin: 0;
        box-sizing: border-box;
        /*height: 49px;*/
        /*border-top: 1px solid #eee;*/
        /*box-shadow: 0 -2px 3px rgba(150, 150, 150, .2);*/
        /*!*box-shadow: 0px -1px 1px rgba(150,150,150,08);*!*/

        /*position:fixed;*/
        /*left:0;*/
        /*right:0;*/
        /*bottom:0;*/

        /*display: flex;*/
        /*text-align: center;*/
    }
</style>